import { Expr } from "../../Expr";

export interface IContainsXpr {
  $type: "icontains";
  instance: Expr;
  arg: Expr;
}

export const icontainsExpr = (instance: Expr, arg: Expr): IContainsXpr => ({
  $type: "icontains",
  instance,
  arg,
});
